import * as Yup from 'yup';
import { OutgoingDocument } from '@models';

export function useValidationSchema() {
  return Yup.object<OutgoingDocument>()
    .shape({
      summary: Yup.string().nullable().required(),
    })
    .test('', '', function (value) {
      console.log(value);
      if (value?.decision) {
        if (!value.linkedDecision?.decisionDate) {
          return this.createError({
            path: 'linkedDecision.decisionDate',
            message: 'Musí být vyplněné',
          });
        }

        if (!value.linkedDecision?.form) {
          return this.createError({
            path: 'linkedDecision.form',
            message: 'Musí být vyplněné',
          });
        }

        if (!value.linkedDecision?.attachments?.fullTextDocx) {
          return this.createError({
            path: 'linkedDecision.attachments.fullTextDocx',
            message: 'Musí být vyplněné',
          });
        }
      }
      return true;
    }) as Yup.Schema<OutgoingDocument>;
}
